import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { Callout, CalloutVariant } from "../../../../Callout";
import { useActionRequest, useDataRequest } from "../../../../../../common/hooks/api";
import { Api } from "../../../../../../common/service/Api";
import { usePrimaryOrganization } from "../../../../../hooks/useOrganization";
import { SUBMIT_FIELD_NAMES } from "../../../DataRequestSubjectCard";
import { useDataRequestProcessingContext } from "../../DataRequestProcessingContext";

export const ProfilingOptOutStep = () => {
  const [org] = usePrimaryOrganization();

  const { request, refreshRequest, setStepCompleted } = useDataRequestProcessingContext();
  const api = useCallback(
    ({ request, finished }) => {
      const existingValues = Object.fromEntries(
        Object.entries(request).filter(([k]) => SUBMIT_FIELD_NAMES.includes(k)),
      );
      const values = Object.assign({}, existingValues, {
        profilingOptOutFinished: finished,
      }) as any;
      return Api.dataRequest.updateRequest(org.id, request.id, values);
    },
    [request],
  );

  const { fetch: updateField } = useActionRequest({ api });

  const handleSelectionUpdated = async (isFinished: boolean) => {
    await updateField({ request, finished: isFinished });
    refreshRequest();
  };

  const { result: fetchedInstructions } = useDataRequest({
    queryKey: ["fetchedProfilingOptOutInstructions", org.id],
    api: () => Api.requestHandlingInstructions.getProfilingOptOutInstructions(org.id),
  });

  useEffect(() => {
    setStepCompleted(request.profilingOptOutFinished ?? false);
  }, [request.profilingOptOutFinished]);

  return (
    <>
      <div className="text-t3 mb-std">
        Your business is required to discontinue using this consumer's personal data for purposes of
        automated profiling that produces legal or similar effects (e.g., determining
        creditworthiness or educational or housing opportunities). Check the box below when you've
        made any necessary changes to your data processing for this consumer.
      </div>

      {Boolean(fetchedInstructions) && (
        <Callout variant={CalloutVariant.Clear} className={"mb-std"}>
          <p>{fetchedInstructions}</p>
        </Callout>
      )}

      <FormControlLabel
        control={
          <Checkbox
            checked={request.profilingOptOutFinished ?? false}
            onChange={({ target }) => handleSelectionUpdated(target.checked)}
          />
        }
        label="We've opted this consumer out of any automated profiling that produces legal or similar effects."
      />
    </>
  );
};
